import { ProductFeedSource } from '@interfaces/api/payloads/product-feed-payload';
import { usePreferences } from '@context/preferences.context';
import useUser from '@hooks/user/use-user';
import { useQuery } from '@tanstack/react-query';
import { getSEMPDPFeedQuery } from '@api/feeds';
import { useMemo } from 'react';
import mapCatalogHitToProduct from '@helpers/utils/catalog/map-catalog-hit-to-product';

interface SemPdpFeedRequest {
  productID: number;
  source: ProductFeedSource;
}

export const useSemPdpFeed = (semPdpFeedRequest: SemPdpFeedRequest) => {
  const preferences = usePreferences();
  const { userId } = useUser();
  const { data } = useQuery(getSEMPDPFeedQuery(preferences, userId, semPdpFeedRequest));

  return useMemo(
    () => ({
      ...data,
      items:
        data?.items?.map((item) =>
          mapCatalogHitToProduct(item, preferences.country, preferences.currency, preferences.language),
        ) ?? [],
    }),
    [data, preferences.country, preferences.currency, preferences.language],
  );
};
